import styled from 'styled-components';
import { media, mediaQuery } from '../../common/styles/styleUtil';

const Kanit = 'Kanit, Helvetica Neue, Helvetica, Arial, sans-serif';

export const SeoFooterWrapper = styled.div`
  background-color: #20282e;
  width: 100%;
  margin-top: 16px;
  padding: 16px 0 32px;
  ${media.xs`
    padding: 16px 5px 32px;
  `};
`;

export const SeoFooterSection = styled.div`
  max-width: 1140px;
  @media (${mediaQuery.tablet}) {
    width: 95%;
  }
  margin: 0 auto;
`;

export const SeoFooterTab = styled.div`
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  // Override Tabs separator line
  .ant-tabs-top > .ant-tabs-nav::before {
    display: none;
  }
  .ant-tabs-tab {
    font-family: ${Kanit};
  }
`;

export const CustomTab = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: ${(props) => (props.active ? '#1890FF' : '#d2d6da')};
  &:hover {
    color: #40a9ff;
    transition: hover 0.3s;
  }
`;

export const SeoFooterTabContentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  .show-more-button {
    margin-top: 0;
    margin-bottom: 24px;
    ::before {
      display: none;
    }
  }
`;

export const SeoFooterContent = styled.div`
  white-space: pre-wrap;
  width: 25%;
  margin-bottom: 24px;
  font-size: 14px;
  ${media.xs`
    width: 100%;
  `};
`;

export const SeoFooterAttribute = styled.p`
  margin: 0;
  line-height: 1.43;
  letter-spacing: normal;
  font-size: 14px;
  font-weight: 500;
  color: #d2d6da;
  a {
    color: #d2d6da;
  }
  a:hover {
    color: #ffffff;
  }
`;
